export default __webpack_public_path__ + "static/media/comistar.4ec6634b.png";